interface cdrResponse {
  Date: string
  weekDay: string
  Time: string
  Direction: string
  OtherParty: string
  Country: string
  Minutes: number
  Data: number
  Message: number
  PricePerUnit: number
  Charge: number
  TollCharge: number
  OtherCharge: string | number
  RoamingCharge: string | number
  Tax: number
  Total: number
  Bundle: string | null
  TypeForInvoice: string
  ServiceKey: string
  Discount: null | number
  TimeProfile: string
  Duration: string
}

interface cdrBodyResponse {
  from_Date: string
  to_Date: string
  phone_number: string
}

const isCdrResponse = (cdr: any): cdr is cdrResponse => {
  if (cdr === undefined) {
    return false
  }
  if (Array.isArray(cdr)) {
    return 'Time' in cdr[0]
  }
  return 'Time' in cdr
}

const isCdrBodyResponse = (cdr: any): cdr is cdrBodyResponse => {
  if (cdr === undefined) {
    return false
  }
  return 'from_date' in cdr
}

export type { cdrResponse, cdrBodyResponse }
export { isCdrResponse, isCdrBodyResponse }
